<script>

	import TrackedContentOverview from "./TrackedContentOverview.svelte";
	import PaidContentOverview from "./PaidContentOverview.svelte";
	import {External, M} from "../../../external";

	export let circle = {}, activePeriod;
	let tab = 'tracked';

</script>

<div class="padding-45 f-left col20">
	<div class="upper-navigation upper-navigation-full inner-upper-nav mb-25">
		<ul>
			<li on:click={() => tab = 'tracked'}><a class:active={tab === 'tracked'}>{M.TRACKED_CONTENT}</a></li>
			<li on:click={() => tab = 'paid'}><a class:active={tab === 'paid'}>{M.PAID_CONTENT}</a></li>
		</ul>
	</div>

	{#key activePeriod}
		{#if tab === 'tracked'}
			<TrackedContentOverview circle={circle} activePeriod={activePeriod}/>
		{:else if tab === 'paid'}
			<PaidContentOverview circle={circle} activePeriod={activePeriod}/>
		{/if}
	{/key}
</div>
